import { resolveAgentTextStreamBucket } from '@buildautomaton/types';
import { extractSessionUpdateMessageText } from './extract-session-update-message-text.js';

type PlanningTurnBuffer = {
  messageBuffer: string;
};

const buffersByRunId = new Map<string, PlanningTurnBuffer>();

export function registerPlanningSessionTurn(runId: string): void {
  buffersByRunId.set(runId, { messageBuffer: '' });
}

export function isPlanningSessionTurn(runId: string): boolean {
  return buffersByRunId.has(runId);
}

export function clearPlanningSessionTurn(runId: string): void {
  buffersByRunId.delete(runId);
}

/** Buffer assistant message text and return true when this update should not hit the transcript. */
export function capturePlanningSessionUpdate(params: {
  runId: string;
  updateKind: string;
  payload: unknown;
}): boolean {
  const state = buffersByRunId.get(params.runId);
  if (!state) return false;

  const sessionUpdate =
    params.payload != null &&
    typeof params.payload === 'object' &&
    !Array.isArray(params.payload)
      ? ((params.payload as Record<string, unknown>).sessionUpdate ??
        (params.payload as Record<string, unknown>).session_update)
      : undefined;

  const bucket = resolveAgentTextStreamBucket({
    transcriptRowKind: params.updateKind,
    sessionUpdate: typeof sessionUpdate === 'string' ? sessionUpdate : undefined,
  });
  if (bucket !== 'message') return false;

  const text = extractSessionUpdateMessageText(params.payload);
  if (text) state.messageBuffer += text;
  return true;
}

export function getPlanningSessionTurnOutput(runId: string): string {
  return buffersByRunId.get(runId)?.messageBuffer ?? '';
}

export function consumePlanningSessionTurnOutput(runId: string): string {
  const state = buffersByRunId.get(runId);
  buffersByRunId.delete(runId);
  return state?.messageBuffer ?? '';
}
